import {
  ArrowBack,
  Assessment,
  ChevronRight,
  ExpandMore,
  FolderOpenRounded,
  FolderRounded,
  Menu,
} from '@mui/icons-material'
import { alpha } from '@mui/material/styles'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView'
import { TreeItem } from '@mui/x-tree-view/TreeItem'
import {
  Box,
  Button,
  Card,
  CardActionArea,
  Collapse,
  Skeleton,
  SwipeableDrawer,
  Typography,
} from '@mui/material'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { ModalTypes } from 'common/hooks/useCustomModal'
import { Fragment, useContext, useEffect, useState } from 'react'
import ThemeManager from 'theming/ThemeManager'
import { InformesContext } from '../providers/InformesProvider'
import '../styles/menuInforme.css'

export default function MenuInforme() {
  const { handleModal } = useContext(CustomModalContext)
  const {
    menu: menuResponse,
    setRedirected,
    active: {
      current,
      setCurrent,
      structure,
      setFilterData,
      setActiveFilter,
      setPage,
      forceRefresh,
    },
  } = useContext(InformesContext)
  const Theme = new ThemeManager()
  const [menuOppened, setMenuOppened] = useState(false)
  const [expandedMenus, setExpandedMenus] = useState({})

  const expandCollapseMenu = (codigo_menu) => {
    const newExpanded = { ...expandedMenus }
    newExpanded[codigo_menu] = !newExpanded[codigo_menu]
    setExpandedMenus(newExpanded)
  }

  const backToMenu = () => {
    setCurrent(null)
    setRedirected(false)
    setFilterData({})
    setActiveFilter({})
    setPage(1)
    forceRefresh()
  }

  useEffect(() => {
    handleModal({ enabled: menuResponse?.loading, type: ModalTypes.Loading })
  }, [menuResponse?.loading])

  /**
   *
   * @param {InformeMenu[]} menuToIterate
   */
  function iterateWideMenu(menuToIterate, isChild = false) {
    if (!menuToIterate) return null

    return (
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: isChild ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
            lg: isChild ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
          },
          gap: 2,
        }}
      >
        {menuToIterate.map((item) => {
          if (item.children?.length <= 0) {
            const isActive = current?.codigo_menu === item.codigo_menu
            return (
              <Card
                key={item.codigo_menu}
                elevation={0}
                sx={(theme) => ({
                  height: '100%',
                  borderRadius: 4,
                  border: '1px solid',
                  borderColor: isActive ? 'primary.main' : 'transparent',
                  backgroundColor: isActive
                    ? alpha(theme.palette.primary.main, 0.12)
                    : alpha(theme.palette.primary.main, 0.05),
                  transition: theme.transitions.create(
                    ['transform', 'box-shadow', 'background-color'],
                    { duration: theme.transitions.duration.shorter },
                  ),
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                  },
                })}
              >
                <CardActionArea
                  onClick={() => setCurrent(item)}
                  sx={{
                    height: '100%',
                    p: 2.5,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    gap: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: 2,
                      display: 'grid',
                      placeItems: 'center',
                      color: 'primary.contrastText',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    <Assessment />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, lineHeight: 1.3, color: 'text.primary' }}
                  >
                    {item.nombre}
                  </Typography>
                  <Box
                    sx={{
                      mt: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      color: 'primary.main',
                    }}
                  >
                    <Typography variant="button" sx={{ fontWeight: 600 }}>
                      Abrir informe
                    </Typography>
                    <ChevronRight fontSize="small" />
                  </Box>
                </CardActionArea>
              </Card>
            )
          }

          const isExpanded = Boolean(expandedMenus[item.codigo_menu])
          return (
            <Fragment key={item.codigo_menu}>
              <Card
                elevation={0}
                sx={(theme) => ({
                  height: '100%',
                  borderRadius: 4,
                  border: '1px solid',
                  borderColor: isExpanded ? 'primary.main' : 'transparent',
                  backgroundColor: alpha(theme.palette.primary.main, 0.05),
                  transition: theme.transitions.create(
                    ['transform', 'box-shadow', 'background-color'],
                    { duration: theme.transitions.duration.shorter },
                  ),
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                  },
                })}
              >
                <CardActionArea
                  onClick={() => expandCollapseMenu(item.codigo_menu)}
                  sx={{
                    height: '100%',
                    p: 2.5,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    gap: 1.5,
                  }}
                >
                  <Box
                    sx={(theme) => ({
                      width: 44,
                      height: 44,
                      borderRadius: 2,
                      display: 'grid',
                      placeItems: 'center',
                      color: 'primary.main',
                      backgroundColor: alpha(theme.palette.primary.main, 0.15),
                    })}
                  >
                    {isExpanded ? <FolderOpenRounded /> : <FolderRounded />}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, lineHeight: 1.3, color: 'text.primary' }}
                  >
                    {item.nombre}
                  </Typography>
                  <Box
                    sx={{
                      mt: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      color: 'primary.main',
                    }}
                  >
                    <Typography variant="button" sx={{ fontWeight: 600 }}>
                      {item.children.length} informes
                    </Typography>
                    <ExpandMore
                      fontSize="small"
                      sx={(theme) => ({
                        transition: theme.transitions.create('transform'),
                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      })}
                    />
                  </Box>
                </CardActionArea>
              </Card>
              <Collapse in={isExpanded} timeout="auto" unmountOnExit sx={{ gridColumn: '1 / -1' }}>
                <Box
                  sx={(theme) => ({
                    mt: 0.5,
                    p: 2,
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.primary.main, 0.03),
                    border: '1px dashed',
                    borderColor: alpha(theme.palette.primary.main, 0.2),
                  })}
                >
                  {iterateWideMenu(item.children, true)}
                </Box>
              </Collapse>
            </Fragment>
          )
        })}
      </Box>
    )
  }

  /**
   *
   * @param {InformeMenu[]} menuToIterate - [TODO:description]
   * @returns {[TODO:type]} [TODO:description]
   */
  function iterateMovilMenu(menuToIterate) {
    return menuToIterate?.map((item, idx) => {
      return (
        <>
          {item.children?.length <= 0 ? (
            <TreeItem
              onClick={() => {
                setCurrent(item)
                setRedirected(false)
                setFilterData({})
                setActiveFilter({})
                setMenuOppened(false)
                setPage(1)
                forceRefresh()
              }}
              itemId={item.codigo_menu}
              label={item.nombre}
            />
          ) : (
            <TreeItem itemId={item.codigo_menu} label={item.nombre}>
              {iterateMovilMenu(item.children)}
            </TreeItem>
          )}
        </>
      )
    })
  }
  function iterateMenus(menoToIterate) {
    return menoToIterate?.map((item, idx) => {
      return (
        <>
          {item.children?.length <= 0 ? (
            <Button
              key={idx}
              disabled={structure?.loading}
              onClick={() => {
                setCurrent(item)
                setRedirected(false)
                setFilterData({})
                setActiveFilter({})
                setPage(1)
                forceRefresh()
              }}
              sx={{ p: 3, whiteSpace: 'nowrap', textAlign: 'left', color: 'text.primary' }}
            >
              {item.nombre}
            </Button>
          ) : (
            <li key={idx} style={{ display: 'flex', flexDirection: 'column' }}>
              <Button
                disabled={structure?.loading}
                sx={{
                  color: 'text.primary',
                  p: 3,
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  justifyContent: 'space-between',
                }}
                endIcon={<KeyboardArrowDown />}
              >
                {item.nombre}
              </Button>
              <ul>{iterateMenus(item.children)}</ul>
            </li>
          )}
        </>
      )
    })
  }
  function buildTree(menuItems) {
    const menuMap = {}
    const tree = []
    menuItems.forEach((item) => {
      menuMap[item.codigo_menu] = { ...item, children: [] }
    })

    menuItems.forEach((item) => {
      if (item.cod_padre && menuMap[item.cod_padre]) {
        menuMap[item.cod_padre].children.push(menuMap[item.codigo_menu])
      } else {
        tree.push(menuMap[item.codigo_menu])
      }
    })

    return tree
  }
  const [menu, setMenu] = useState()
  useEffect(() => {
    if (!menuResponse.response) return
    setMenu(buildTree(menuResponse.response))
  }, [menuResponse.response])

  return (
    <>
      {current?.isNestedReport ? (
        <></>
      ) : current?.nombre_informe ? (
        <Box sx={{ mb: 3 }}>
          <Button
            onClick={backToMenu}
            startIcon={<ArrowBack />}
            sx={{
              mb: 1,
              textTransform: 'none',
              fontWeight: 600,
              color: 'primary.main',
              '&:hover': {
                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
              },
            }}
          >
            Volver a informes
          </Button>
          <Box sx={{ display: { xs: 'flex', sm: 'none' }, justifyContent: 'end' }}>
            <Button
              sx={{ display: 'flex' }}
              onClick={() => {
                setMenuOppened(!menuOppened)
              }}
              endIcon={<Menu />}
            >
              Menú{' '}
            </Button>
          </Box>

          <SwipeableDrawer
            anchor="right"
            open={menuOppened}
            onClose={() => setMenuOppened(false)}
            onOpen={() => setMenuOppened(true)}
          >
            <Box sx={{ width: '70vw' }}>
              <SimpleTreeView
                sx={{ mt: 3 }}
                aria-label="file system navigator"
                slots={{ collapseIcon: ExpandMore, expandIcon: ChevronRight }}
              >
                {iterateMovilMenu(menu)}
              </SimpleTreeView>
            </Box>
          </SwipeableDrawer>

          <Box sx={{ mb: 4, display: { xs: 'none', sm: 'initial' } }}>
            {!menuResponse.loading ? (
              <>
                <ul
                  className="menuInforme"
                  style={{
                    display: 'flex',
                    listStyle: 'none',
                    gap: '5px',
                    '--global-bg': Theme.pallete.background.default,
                  }}
                >
                  {iterateMenus(menu)}
                </ul>
              </>
            ) : (
              <Box sx={{ display: 'flex', gap: '3px' }}>
                <Skeleton>
                  <Button>Texto</Button>
                </Skeleton>
                <Skeleton>
                  <Button>Texto mas largo</Button>
                </Skeleton>
                <Skeleton>
                  <Button>Texto medio</Button>
                </Skeleton>
              </Box>
            )}
          </Box>
        </Box>
      ) : (
        <Box sx={{ mt: 1 }}>{iterateWideMenu(menu)}</Box>
      )}
      {menuResponse?.loading ? (
        <>
          {current?.nombre_informe ? (
            <>
              <Box sx={{ display: 'flex', gap: '3px' }}>
                <Skeleton>
                  <Button>Texto</Button>
                </Skeleton>
                <Skeleton>
                  <Button>Texto mas largo</Button>
                </Skeleton>
                <Skeleton>
                  <Button>Texto medio</Button>
                </Skeleton>
              </Box>
            </>
          ) : (
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: 'repeat(2, 1fr)',
                  md: 'repeat(3, 1fr)',
                  lg: 'repeat(4, 1fr)',
                },
                gap: 2,
                mt: 1,
              }}
            >
              {Array.from({ length: 8 }).map((_, idx) => (
                <Skeleton key={idx} variant="rounded" height={150} sx={{ borderRadius: 4 }} />
              ))}
            </Box>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  )
}
